var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hello"},[_c('p',{staticClass:"m-4"},[_vm._v(" Find out which of your friends are free to hang out. The week of. ")]),_c('div',{staticClass:"form"},[_c('a',{staticClass:"m-4",attrs:{"href":"https://apps.apple.com/app/id6445856722"}},[_c('img',{staticClass:"appImg",attrs:{"src":require("../assets/app.svg"),"alt":"app store"}})])])])
}]

export { render, staticRenderFns }